/**
 * @desc: - 挂件-侧边栏 小图标、文字
 * @param  {[STRING]} className：   [icon class]
 * @param  {[STRING]} text:         [显示文字]
 * @param  {[STRING]} url:          [跳转地址]
 * @author: klaf
 */
import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as baseAction from '../../actions/baseAction';
import {
  DOMAIN,
  DOWNLOAD_CENTER,
  DOWNLOAD_APP_QR,
  DOWNLOAD_HANGUP_PC,
  DOWNLOAD_HANGUP_README,
  DOWNLOAD_APP_HANGUP_QR,
    ZH_DOWNLOAD_APP_QR,
  HY_DOWNLOAD_AUTOLOTT_PC
} from '../../constants/config.js';
import {DOWNLOAD_CEF_PC} from "../../constants/config";
import {ServiceBox} from '../../containers/pc-day/UserAgreement.jsx'

class SideBar extends React.Component {

  constructor(props) {
    super(props);
    this.showHangUpQr = this.showHangUpQr.bind(this)
    this.hideHangUpQr = this.hideHangUpQr.bind(this)
    this.state = {
      qrDisplay: false
    }
    // this.imgUrl = DOWNLOAD_APP_QR + "?n=" + Math.random()
    this.hangUpQr = DOWNLOAD_APP_HANGUP_QR + "?n=" + Math.random()
    this.autolottPC = HY_DOWNLOAD_AUTOLOTT_PC + "?n=" + Math.random()
    this.downCenter = DOWNLOAD_CENTER + "?n=" + Math.random()
  }

  // 声音控制
  SoundToggle() {
    const __base = this.props.__BASE.toJS();
    if (__base.config.soundNotice) {
      this.props.$$BASE.stopSoundNotice()
    } else {
      this.props.$$BASE.startSoundNotice()
    }

  }

  // 打开聊天窗口
  openChat() {
    var _top = (window.innerHeight - 427) / 2;
    var _left = (window.innerWidth - 985) / 2;
    window.open(DOMAIN + 'chat?version=x', 'newwindow', 'height=527,width=970,top = ' + _top + ',left =' + _left + ',toolbar =no,menubar=no,scrollbars=no,resizable=no,location=no,status=no');
  }

  showHangUpQr() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    if (this.timer1) {
      clearTimeout(this.timer1)
    }
    this.timer1 = setTimeout(() => {
      this.setState({
        qrDisplay: true
      })
    }, 101)
  }

  hideHangUpQr() {
    if (this.timer1) {
      clearTimeout(this.timer1)
    }
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.timer = setTimeout(() => {
      this.setState({
        qrDisplay: false
      })
    }, 100)
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    if (this.timer1) {
      clearTimeout(this.timer1)
    }
  }

  // 返回顶部
  GoToTop(row, poxy, event, speed, time) {
    speed = speed || 0.3;
    time = time || 15;
    var x1 = 0, y1 = 0, x2 = 0, y2 = 0, x3 = 0, y3 = 0;
    if (document.documentElement) {
      x1 = document.documentElement.scrollLeft || 0;
      y1 = document.documentElement.scrollTop || 0;
    }
    if (document.body) {
      x2 = document.body.scrollLeft || 0;
      y2 = document.body.scrollTop || 0;
    }
    x3 = window.scrollX || 0;
    y3 = window.scrollY || 0;

    var x = Math.max(x1, Math.max(x2, x3));
    var y = Math.max(y1, Math.max(y2, y3));
    var seed = 1 + speed;//加速度
    window.scrollTo(Math.floor(x / seed), Math.floor(y / seed));

    if (x > 0 || y > 0) {
      window.setTimeout(function () {
        this.GoToTop(poxy, event, row, speed, time);
      }.bind(this), time);
    }
  }

  open(){
    this.props.$$BASE.openAlert('敬请期待！')
  }

  toggleSlideBar() {
    const __base = this.props.__BASE.toJS();
    const __user = this.props.__USER.toJS();
    const __common = this.props.__COMMON.toJS();
    const {settings} = __common
    const vers = $.getCookie('vers');
    const ads = _.filter(__base.ads, (item) => item.type == 'navigator');
    let {hasClass} = this.props
    hasClass = hasClass || "";
    let hash = window.location.hash;
    if(vers == 'zh'){
      return (
        <div className={hasClass + " affix-sidebar-rec"}>
          <a href={__common.settings ? __common.settings['customer_service_url'] : 'javascript;;'} target="_blank" className="sidebar-div">
            <span>客服</span>
          </a>
          <a className="sidebar-div appDownload" href="javascript:;" target='_blank'>
            <span>APP</span>
            <div style={{animation: hash == '#/' ? "code-animate 2s" : 'none'}} className="code-warp ">
              <b><img src={settings.app_download_url}/></b>
            </div>
          </a>

          <a className="sidebar-div personal" href={"#/report/personal/management/index"} target='_self'>
            <span>我的</span>
          </a>
          <a className="sidebar-div chat" onClick={this.openChat}>
            <span>聊天</span> <b className="s_msg" style={{display: __user.chat.count > 0 ? 'block' : 'none'}}></b>
          </a>
          <a href={"#/report/help/playinfo"} className="sidebar-div help">
            <span>帮助</span>
          </a>
          <a className={"sidebar-div sound" + (__base.config.soundNotice ? '  soundon' : '  soundoff')}
             onClick={this.SoundToggle.bind(this)}>
            <span>声音</span>
          </a>
          <a className="sidebar-div goup" onClick={this.GoToTop.bind(this)}>
          </a>
        </div>
      )
    }else if(vers == 'df'){
      return (
        <div className={hasClass + " affix-sidebar-rec"}>
          {/* <a href='mailto:cs@dafucai.net' target="_blank" className="sidebar-div">
            <span>客服</span>
          </a> */}
          <a className="sidebar-div personal" href={"#/report/personal/management/index"} target="_self">
            <span>my center</span>
          </a>
          {/* <a className="sidebar-div chat" onClick={this.openChat}>
            <span>聊天</span> <b className="s_msg" style={{display: __user.chat.count > 0 ? 'block' : 'none'}}></b>
          </a>
          <a href={"#/report/help/playinfo"} className="sidebar-div help">
            <span>帮助</span>
          </a>
          <a className={"sidebar-div sound" + (__base.config.soundNotice ? '  soundon' : '  soundoff')}
             onClick={this.SoundToggle.bind(this)}>
            <span>声音</span>
          </a>
          <a className="sidebar-div goup" onClick={this.GoToTop.bind(this)}>
          </a> */}
        </div>
      );
    }else{
      return (
        <div className={hasClass + " affix-sidebar-rec"}>
          {
            __common.settings&&__common.settings.agreement?<ServiceBox settings={__common.settings} openAlert={this.props.$$BASE.openAlert}/>:
            <a href={__common.settings ? __common.settings['customer_service_url'] : 'javascript;;'} target="_blank"
                className="sidebar-div kefu">
              <span>客服</span>
            </a>
          }
          {
            ads && ads.map((item, index) => <a key={index} href={item.forward.url} target={item.forward.type} className="sidebar-div ext-menus"><span><img src={item.image}/></span></a>)
          }
          <a className="sidebar-div appDownload" href={this.downCenter} target='_blank'>
            <span>APP</span>
            <div style={{animation: hash == '#/' ? "code-animate 2s" : 'none'}} className="code-warp ">
              <b><img src={settings.app_download_url}/></b>
            </div>
          </a>
          <a className="sidebar-div personal" href={"#/report/personal/management/index"} target='_self'>
            <span>我的</span>
          </a>
          <a className="sidebar-div chat" onClick={this.openChat}>
            <span>聊天</span> <b className="s_msg" style={{display: __user.chat.count > 0 ? 'block' : 'none'}}></b>
          </a>
          <a href={"#/report/help/playinfo"} className="sidebar-div help">
            <span>帮助</span>
          </a>
          <a className={"sidebar-div sound" + (__base.config.soundNotice ? '  soundon' : '  soundoff')}
             onClick={this.SoundToggle.bind(this)}>
            <span>声音</span>
          </a>

          <a target="_blank" href={settings.pc_client_download_url} className="sidebar-div deskTop">
            <span>PC</span>
          </a>
          <a href={settings.hangup_pc_download_url} className="sidebar-div hangUp" target='_blank'>
            <span>挂机</span>
          </a>
          <a className="sidebar-div goup" onClick={this.GoToTop.bind(this)}></a>
        </div>
      )
    }
  }

  render() {
    return <div>
        {
          this.toggleSlideBar()
        }
        </div>

  }
}

reactMixin(SideBar.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __USER: state.user,
    __COMMON: state.common
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch),
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SideBar)
